import { LocalCharacterInitializer } from "../../../../../entities/characters/Character";
import { CharacterState } from "../CharacterStore.State";
import { CharacterAddCompetency, CharacterAddCustomCompetency, CharacterRemoveCompetency, CharacterSetCompetencyLevel } from "../actions/CharacterCompetencyActions";
import { CharacterReducerHelpers } from "./CharacterReducerHelpers";

const addCompetency = (state: CharacterState, action: CharacterAddCompetency): CharacterState => {
    const { characterId, reference } = action;
    const character = CharacterReducerHelpers.getCharacter(state, characterId);
    if (character == null) {
        return state;
    }

    const newCharacter = {
        ...character,
        competencies: [...character.competencies, reference]
    };

    return CharacterReducerHelpers.updateCharacter(state, newCharacter);
}

const addCustomCompetency = (state: CharacterState, action: CharacterAddCustomCompetency): CharacterState => {
    const { characterId, competency } = action;
    const character = CharacterReducerHelpers.getCharacter(state, characterId);
    if (character == null) {
        return state;
    }

    const newCharacter = {
        ...character,
        customCompetencies: [...character.customCompetencies, competency]
    };

    return CharacterReducerHelpers.updateCharacter(state, newCharacter);
}

const removeCompetency = (state: CharacterState, action: CharacterRemoveCompetency): CharacterState => {
    const { characterId, competencyId } = action;
    const character = CharacterReducerHelpers.getCharacter(state, characterId);
    if (character == null) {
        return state;
    }

    const newCharacter = {
        ...character,
        competencies: character.competencies.filter(c => c.id != competencyId)
    };

    return CharacterReducerHelpers.updateCharacter(state, newCharacter);
}

const setCompetencyLevel = (state: CharacterState, action: CharacterSetCompetencyLevel): CharacterState => {
    const { characterId, competencyId, isExpert } = action;
    const character = CharacterReducerHelpers.getCharacter(state, characterId);
    if (character == null) {
        return state;
    }

    let newCharacter: LocalCharacterInitializer;
    const oldCompetency = character.competencies.find(c => c.id == competencyId);
    const oldCustomComptency = character.customCompetencies.find(c => c.id == competencyId);


    if (oldCompetency != null) {
        const competency = { ...oldCompetency, isExpert };
        newCharacter = {
            ...character,
            competencies: [
                ...character.competencies.filter(c => c.id != competencyId),
                competency
            ]
        }
    }
    else if (oldCustomComptency != null) {
        const competency = { ...oldCustomComptency, isExpert };
        newCharacter = {
            ...character,
            customCompetencies: [
                ...character.customCompetencies.filter(c => c.id != competencyId),
                competency
            ]
        }
    }
    else {
        console.error("Attempted to set competency level on an unknown competency")
        return state;
    }

    const pendingProperties = { ...newCharacter.pendingProperties };
    delete newCharacter.pendingProperties[competencyId];

    newCharacter = { ...newCharacter, pendingProperties };

    return CharacterReducerHelpers.updateCharacter(state, newCharacter);
}


export const CharacterCompetencyReducers = {
    addCompetency,
    addCustomCompetency,
    removeCompetency,
    setCompetencyLevel,
}